<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Max Bids</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="max_bids" type="text" placeholder="Max bids" :class="{ 'is-danger': errors.max_bids }">
                    <span class="icon is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                    <p v-if="errors.max_bids" class="help is-danger">{{ errors.max_bids[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            max_bids: {
                get() {
                    return this.$store.getters.getNewPricePlan.max_bids
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'max_bids', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/MaxBidsInput.vue